import List from "./List";
import Profile from "./Profile";

const routes = [
    {
        path: 'users',
        element: <List />
    },
    {
        path: 'user/profile',
        element: <Profile />
    }
]
export default routes;